import {combineReducers} from 'redux';
import auth from './auth';
import departments from './departments'

export default combineReducers({
    auth,
    departments

});